import type { BmiPageData } from "./generator";
import { buildCalculatorLd } from "@/lib/page-schemas";

/**
 * JSON-LD scripts stack for BMI pSEO pages.
 * Deliberately NOT emitting reviewedBy (Person) — we ship a generic
 * editorial byline, so a fake credentialed reviewer schema would be a
 * YMYL red flag.
 */
export function bmiPageScripts(data: BmiPageData) {
  const medicalPage = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    name: data.meta.h1,
    url: data.meta.canonical,
    description: data.meta.description,
    
    
    
    medicalAudience: {
      "@type": "MedicalAudience",
      audienceType: data.gender === "Female" ? "Women" : "GeneralPublic",
    },
  };
  const calculatorScripts = buildCalculatorLd({
    url: data.meta.canonical,
    name: data.meta.title,
    description: data.meta.description,
    applicationCategory: "HealthApplication",
    featureList: ["Metric and imperial BMI", "Live classification visual", "Step-by-step formula", "Shareable calculation"],
    howTo: {
      name: `How to use ${data.meta.h1}`,
      totalTime: "PT2M",
      steps: [
        { name: "Enter measurements", text: "Enter age, height, and weight using metric or imperial units." },
        { name: "Review BMI", text: "Read the calculated BMI and the matching screening category." },
        { name: "Check the working", text: "Review unit conversions and the step-by-step BMI formula before saving the result." },
      ],
    },
    faqs: data.faqs,
    trail: [
      { name: "Home", item: "https://drhint.com/" },
      { name: "Age Calculator", item: "https://drhint.com/age-calculator" },
      { name: "BMI Directory", item: "https://drhint.com/bmi-calculator" },
      { name: data.meta.h1, item: data.meta.canonical },
    ],
  });
  const medicalScript = {
    type: "application/ld+json",
    children: JSON.stringify(medicalPage),
  };
  return [...calculatorScripts, medicalScript];
}